<template>
  <div
    class="min-h-screen bg-gray-100 flex flex-col justify-center items-center px-7"
  >
    <div class="max-w-md w-full bg-white shadow-lg rounded-lg p-8 text-center">
      <p class="text-xl text-gray-600 mb-6">
        죄송합니다. 요청하신 페이지를 찾을 수 없습니다.
      </p>
      <router-link
        to="/"
        class="inline-block bg-gray-500 hover:bg-gray-600 text-white py-2 px-4 rounded transition duration-300"
      >
        메인으로 돌아가기
      </router-link>
    </div>
    <!-- <p class="mt-8 text-gray-600">
      문제가 지속되면
      <a href="#" class="text-blue-500 hover:underline">고객센터</a>로 문의해
      주세요.
    </p> -->
  </div>
</template>

<script>
export default {
  name: 'NotFoundPage',
};
</script>
